import { Link } from "@tanstack/react-router";
import { SocialLinks } from "@/components/Social";
import { GOOGLE_MAPS_URL, GOOGLE_REVIEW_URL } from "@/lib/site";
import { reopenCookieBanner } from "@/lib/consent";

const pagine = [
  { to: "/trattamento-cotto-esterno", label: "Trattamento cotto esterno" },
  { to: "/trattamento-marmo-pietre-graniglia", label: "Marmo, pietre e graniglia" },
  { to: "/pulizia-trattamento-gres", label: "Gres e pavimenti industriali" },
  { to: "/come-pulire-il-cotto", label: "Come pulire il cotto" },
  { to: "/trattamento-pavimenti-cotto-brescia", label: "Cotto a Brescia" },
  { to: "/trattamento-pavimenti-cotto-bergamo", label: "Cotto a Bergamo" },
  { to: "/trattamento-pavimenti-cotto-milano", label: "Cotto a Milano" },
  { to: "/contattaci", label: "Contatti" },
] as const;

export function SiteFooter() {
  return (
    <footer className="border-t border-border bg-secondary/50 py-10">
      <div className="mx-auto max-w-6xl px-5 text-sm text-muted-foreground">
        <nav aria-label="Pagine del sito" className="flex flex-wrap gap-x-6 gap-y-2">
          {pagine.map((p) => (
            <Link key={p.to} to={p.to} className="transition-colors hover:text-primary">
              {p.label}
            </Link>
          ))}
        </nav>
        <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2">
          <a
            href={GOOGLE_MAPS_URL}
            target="_blank"
            rel="noreferrer"
            className="transition-colors hover:text-primary"
          >
            Artigiani del Cotto su Google
          </a>
          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noreferrer"
            className="font-medium text-primary underline-offset-4 hover:underline"
          >
            Lascia una recensione
          </a>
          <button
            type="button"
            onClick={reopenCookieBanner}
            className="transition-colors hover:text-primary"
          >
            Preferenze cookie
          </button>
        </div>
        <div className="mt-8 flex flex-col gap-4 border-t border-border pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 Artigiani del Cotto · P.IVA 03451350171</p>
          <SocialLinks />
        </div>
      </div>
    </footer>
  );
}
